// extracted by mini-css-extract-plugin
export default {"content":"terms-and-conditions_content__6yCm4","important":"terms-and-conditions_important__UrovL","button":"terms-and-conditions_button__XVJPv"};